import apiService from './api';
import { OrganizationDTO } from '../types/organization';


const ORGANIZATION_BASE_PATH = '/organization';

export const organizationService = {
  getOrganizations: async (): Promise<OrganizationDTO[]> => {
    const response = await apiService.get<OrganizationDTO[]>(`${ORGANIZATION_BASE_PATH}/all`);
    return response.data;
  },

  getAllPlatformOrganizations: async (): Promise<OrganizationDTO[]> => {
    const response = await apiService.get<OrganizationDTO[]>(`${ORGANIZATION_BASE_PATH}/all-platform`);
    return response.data;
  },

  getOrganizationById: async (id: string, forPlatformCuratorOrAdmin: boolean = false): Promise<OrganizationDTO> => {
    const response = await apiService.get<OrganizationDTO>(`${ORGANIZATION_BASE_PATH}/${id}`, { params: { forPlatformCuratorOrAdmin } });
    return response.data;
  },

  createOrganization: async (data: OrganizationDTO): Promise<OrganizationDTO> => {
    const response = await apiService.post<OrganizationDTO>(`${ORGANIZATION_BASE_PATH}/create`, data);
    return response.data;
  },

  updateOrganization: async (data: OrganizationDTO): Promise<OrganizationDTO> => {
    const response = await apiService.put<OrganizationDTO>(`${ORGANIZATION_BASE_PATH}/${data.id}`, data);
    return response.data;
  },
};

export const { getOrganizations, getOrganizationById, createOrganization, updateOrganization } = organizationService;
